import { Injectable } from '@angular/core';
import { AuthenticationDataService } from "@mol-limo-reg/admin-api";
import { LoginRequest, LoginResponse } from "@mol-limo-reg/admin-api/model/models";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private readonly authenticationDataService: AuthenticationDataService) {}

  public logIn$(loginRequest: LoginRequest): Observable<LoginResponse> {
    return this.authenticationDataService.logIn(loginRequest, 'body');
  }

  public logOut$(): Observable<any> {
    return this.authenticationDataService.logOut('body');
  }
}
